<template>
  <footer id="footer">
    <!-- container -->
    <div class="container">
      <!-- row -->
      <div class="row">
        <div class="col-md-3">
          <div class="footer-widget">
            <div class="footer-logo">
              <a href="#/" class="logo">
                <img src="../assets/images/pedline-logo.png" />
              </a>
            </div>
            <p>
              Rua Delfino Cintra, 63 Centro - CEP: 13013-055 Campinas, SP
              <br />
              <br />Tel: <a rel="noreferrer" href="tel:551932312811">19 3231-2811</a>
              <br />E-mail:
              <a rel="noreferrer" href="mailto:contato@pedline.org.br">contato@pedline.org.br</a>
              <br />
              <br />
              <a href="#/contato">CONTATO</a>
            </p>
            <ul class="contact-social">
              <li>
                <a
                  href="https://www.facebook.com/pedlinepediatria/"
                  rel="noreferrer"
                  target="_blank"
                  class="social-facebook"
                >
                  <i class="fa fa-facebook"></i>
                </a>
              </li>
              <!-- <li><a href="#" class="social-twitter"><i class="fa fa-twitter"></i></a></li> -->
              <li>
                <a
                  href="https://www.instagram.com/pedlinepediatria/"
                  rel="noreferrer"
                  target="_blank"
                  class="social-instagram"
                >
                  <i class="fa fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-widget">
            <h3 class="footer-title">Categorias</h3>
            <div class="category-widget">
              <ul>
                <li v-for="cat in categories" :key="cat.id">
                  <a :href="`#/busca?category=${cat.title}`">
                    {{ cat.title }}
                    <span>--</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-widget">
            <h3 class="footer-title">Tags</h3>
            <div class="tags-widget">
              <ul>
                <li v-for="tag in tags.slice(0, 10)" :key="tag.id">
                  <a :href="`#/busca?tag=${tag.title}`">{{ tag.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-widget">
            <h3 class="footer-title">Newsletter</h3>
            <div class="newsletter-widget">
              <div style="position:relative;z-index:2;">
                <p>Mantenha-se informado sobre nossas novidades.</p>
                <input
                  class="input"
                  name="newsletter"
                  v-model="newsletter.email"
                  placeholder="Informe o seu e-mail"
                />

                <transition enter-active-class="animated fadeIn">
                  <p style="color:#8bc725;" v-show="messageSent">
                    E-mail cadastrado. Obrigado pelo interesse!
                  </p>
                </transition>

                <transition enter-active-class="animated fadeIn">
                  <p style="color:#f00;" v-show="warningMessage != ''">
                    {{ warningMessage }}
                  </p>
                </transition>
                <button @click="sendNewsletter" class="primary-button">
                  <div v-show="!newsletterLoading">INSCREVA-SE</div>
                  <div v-show="newsletterLoading" class="loading-spinner"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /row -->

      <!-- row -->
      <div class="footer-bottom row">
        <div class="col-md-6">
          <ul class="footer-nav">
            <li>
              <a href="#/">Home</a>
            </li>
            <li>
              <a href="#/quemSomos">Quem somos</a>
            </li>
            <li>
              <a href="#/parceiros">Parceiros e apoio</a>
            </li>
            <li>
              <a href="#/contato">Contato e imprensa</a>
            </li>
          </ul>
        </div>
        <div class="col-md-6 developer-holder">
          <span class="mr-2">Desenvolvido por:</span>
          <a href="https://rubik.studio" rel="noreferrer" target="_blank">
            <img src="../assets/images/rubik-studio.png" alt="Rubik Studio" />
          </a>
        </div>
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->
  </footer>
</template>

<script>
import http from "@/http";
import validators from "../util/validators";

export default {
  name: "Footer",
  data() {
    return {
      tags: [],
      categories: [],
      newsletterLoading: false,
      newsletter: {
        email: ""
      },
      warningMessage: "",
      messageSent: false
    };
  },
  created() {
    this.loadTags();
    this.loadCategories();
  },
  methods: {
    loadTags() {
      http
        .get("tag")
        .then(response => {
          this.tags = response.data.list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadCategories() {
      http
        .get("category")
        .then(response => {
          this.categories = response.data.list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    sendNewsletter() {
      if (this.newsletter.email == "") {
        this.warningMessage = "Por favor, informe o seu e-mail.";
        return;
      }

      if (!validators.validateEmail(this.newsletter.email)) {
        this.warningMessage = "Por favor, informe um e-mail correto.";
        return;
      }

      this.warningMessage = "";
      this.newsletterLoading = true;

      http
        .post("newsletter", this.newsletter)
        .then(response => {
          this.messageSent = true;
          this.newsletter.email = "";
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.newsletterLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue